import React from "react";
import { Field } from "@design-system/Field/Field";
import { Picker } from "@design-system/Picker/Picker.lib";
import type { PickerItemData } from "@design-system/Picker/Picker.types";
import {
    NATIVE_INVOICE_PAGE_SIZE_DIMENSIONS,
    NATIVE_INVOICE_PAGE_SIZE_LABELS,
    NativeInvoicePageSize,
} from "./nativeInvoiceFormTypes";
import { useNativeInvoiceFormContext } from "./NativeInvoiceFormContext";
import styles from "./SidePanel.module.scss";

const PAGE_SIZE_ITEMS: Array<PickerItemData<NativeInvoicePageSize>> = (
    ["letter", "a4"] satisfies NativeInvoicePageSize[]
).map((pageSize) => ({
    value: pageSize,
    label: NATIVE_INVOICE_PAGE_SIZE_LABELS[pageSize],
    labelHint: NATIVE_INVOICE_PAGE_SIZE_DIMENSIONS[pageSize],
}));

const PageSizeOptionLabel: React.FC<{ pageSize: NativeInvoicePageSize }> = ({
    pageSize,
}) => (
    <>
        {NATIVE_INVOICE_PAGE_SIZE_LABELS[pageSize]}
        <span className={styles.fieldOptionMeta}>
            {NATIVE_INVOICE_PAGE_SIZE_DIMENSIONS[pageSize]}
        </span>
    </>
);

export const NativeInvoicePageSizeField: React.FC = () => {
    const { state, setState } = useNativeInvoiceFormContext();

    return (
        <Field label="Format" control="button">
            <Picker.Select
                items={PAGE_SIZE_ITEMS}
                value={state.pageSize}
                onValueChange={(pageSize) => {
                    if (pageSize === null) {
                        return;
                    }
                    setState((prev) => ({
                        ...prev,
                        pageSize,
                    }));
                }}
                placeholder="Select"
                renderValue={() => (
                    <PageSizeOptionLabel pageSize={state.pageSize} />
                )}
                trigger={<Picker.Button variant="primary" size="xl" />}
            />
        </Field>
    );
};
